import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router';

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    dialogEdit: {m: false, e: null, d: null, id:null},
    locale: null,
    packageVersion: process.env.VUE_APP_VERSION || '2',
    d: false,
    roles: [],
    snackSignup: false,
    filterIcon: false,
    filterPointsDrawer: false,
    dialog: {refresh: Math.random().toString(36), id: null, data: null},
  },
   getters: {
     roles: (state) => state.roles,
     locale: (state)=> state.locale,
     appVersion: (state) =>  state.packageVersion,
     user: (state) =>  state.user,
     dialog: (state) => state.d,
     filterPointsDrawer: (state) => state.filterPointsDrawer,
     filterIcon: (state) => state.filterIcon
   },
  mutations: {
    SET_DIALOG_EDIT(state, o) {
      state.dialogEdit.d = o.data;
        state.dialogEdit.id = o.id;
      state.dialogEdit.m = o.m;
      state.dialogEdit.e = o.e;
    },
    SET_ROLES(state, o) {
      state.roles = o;
    },
    SET_LOCALE(state, value) {
      state.locale = value;
    },
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SHOW_SIGNUP_MESSAGE(state) {
      state.snackSignup = true;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_CLAIMS(state, data) {
      state.user.data.admin = data.admin;
      state.user.data.partner = data.partner;
      state.user.data.partnerships = data.partnerships;
    },
    UPDATE_SCORE(state) {
     state.user.data.score = 0;
     let arr = state.user.data.validations;
     let s = arr.reduce((s, v) => s + v.value, 0);
     state.user.data.score = s;
    },
    SET_VALIDATIONS(state, data) {
       state.user.data.validations = data;
   },
    ADD_VALIDATION(state, data) {
      state.user.data.validations.push(data);
    },
    filterPointsDrawer (state) {
      state.filterPointsDrawer = !state.filterPointsDrawer;
    },
    setFilterIcon(state, d) {
      state.filterIcon = d.state;
    },
    setDataDialog(state, d) {
      state.dialog.id = d.id;
      state.dialog.data = d.data;
      state.dialog.refresh = Math.random().toString(36);
    },
    openD (state) {
      state.d = true;
    },
    closeDialog(state) {
      state.d = false;
    }
},
actions: {
  setRoles({commit}, val) {
    commit('SET_ROLES', val);
  },
  setDialogEdit({commit}, val) {
    commit('SET_DIALOG_EDIT', val);
  },
  setLocale({commit}, locale) {

     commit("SET_LOCALE", locale);
  },
  closeDialog({commit}, data) {
    if (data.cleanHash == true) {
      router.push({hash: null});
    }
    commit('closeDialog');
  },
  showSignUpMessage({commit}) {
    commit("SHOW_SIGNUP_MESSAGE");
  },
  async setValidations({commit}, data) {
    await commit("SET_VALIDATIONS", data);
    commit('UPDATE_SCORE');
  },
  async addValidation({commit}, data) {
    await commit("ADD_VALIDATION", data);
    commit('UPDATE_SCORE');
  },
  fetchUser({ commit }, user) {

    commit("SET_LOGGED_IN", user !== null);
    if (user) {

      commit("SET_USER", {
        displayName: user.displayName,
        email: user.email,
        uid: user.uid,
        score: null,
        admin: null,
        partner: null,
        partnerships: [],
        validations: [],
        picture: user.photoURL
      });
      user.getIdTokenResult().then((t) => {
        commit('SET_CLAIMS', t.claims);
      });

    } else {
      commit("SET_USER", null);
    }
  },
  async setFilterIcon({commit}, state) {
    commit('setFilterIcon', state);
  },
  async openFilterPointsDrawer({commit}) {
    await commit('filterPointsDrawer');
  },
  async openDialog({commit}, state) {
    // On va setter l'ID et la data
    await commit('setDataDialog', state);
    commit('openD');
    // et on va ouvrir
  },
}
});
export default store
